import {
  Field,
  GraphQLLocalDateTime,
  ID,
  ObjectType,
  registerEnumType,
} from '@warebee/shared/util-backend-only-types';

export enum PicklistSetStorageType {
  POSTGRES = 'POSTGRES',
  ATHENA = 'ATHENA',
}

registerEnumType(PicklistSetStorageType, {
  name: 'PicklistSetStorageType',
});

@ObjectType()
export class PicklistTerminalLocationDetails {
  @Field(() => ID)
  locationId: string;

  @Field()
  distance: number;

  @Field()
  duration: number;

  @Field()
  cost: number;
}

@ObjectType()
export class SourceEventDetails {
  @Field(() => ID, { nullable: true })
  sourceEventId?: string;

  @Field(() => GraphQLLocalDateTime, { nullable: true })
  sourceEventDate?: string;
}

@ObjectType()
export class PicklistDetails {
  @Field(() => ID, { nullable: true })
  startLocationId?: string;

  @Field(() => ID, { nullable: true })
  endLocationId?: string;

  @Field(() => ID, { nullable: true })
  shipmentId?: string;

  @Field(() => [PicklistTerminalLocationDetails], { nullable: true })
  possibleEndLocations?: PicklistTerminalLocationDetails[];

  @Field(() => SourceEventDetails, { nullable: true })
  startSourceEvent?: SourceEventDetails;

  @Field(() => SourceEventDetails, { nullable: true })
  endSourceEvent?: SourceEventDetails;
}
